export default __webpack_public_path__ + "static/media/coelho.e3e45b15.JPG";